export async function compressImage(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function (event: ProgressEvent<FileReader>) {
      if (event.target) {
        image.src = event.target.result as string;

        image.onload = function () {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          let width = image.width;
          let height = image.height;
          const maxDimension = Math.max(width, height);
          const scaleFactor = maxDimension > 2000 ? 2000 / maxDimension : 1;
          width *= scaleFactor;
          height *= scaleFactor;
          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(image, 0, 0, width, height);

          canvas.toBlob(
            function (blob) {
              if (blob) {
                const compressedFile = new File([blob], file.name, {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                });
                resolve(compressedFile);
              } else {
                reject(
                  new Error(
                    'A imagem não pôde ser comprimida para 1MB ou menos.',
                  ),
                );
              }
            },
            'image/jpeg',
            0.6,
          );
        };
      }
    };
    reader.onerror = function () {
      reject(new Error('Erro ao ler a imagem.'));
    };
  });
}
